<template>
  <div>
    <!-- Media -->
    <ValidationProvider
      v-slot="{ errors }"
      ref="mediaValidationProviderRef"
      name="Media"
      rules=""
      class="sb-form-group">
      <b-form-group>
        <label
          for="p-key"
          class="settings__label flex flex-align-center" >
          Media
          <!-- <SBIcon
            id="media-description"
            class="ml-1"
            :icon="SBIconList.INFORMATION"
            :color="SBColors.greyPrimary"
            :size="12" /> -->
        </label>
        <div id="attachment-wrapper">
          <DropZone
            ref="dropZone"
            v-model="file"
            :temp-file-name="tempFileName"
            value="test me"
            :max-file-size="16000000"
            @clear="tempFileName = ''"
            @error="(shown) => showFileError = shown" />
        </div>
        <div
          v-if="errors[0]"
          class="error flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ errors[0] }}</span>
        </div>
        <!-- <b-popover
          target="media-description"
          triggers="hover"
          placement="bottom">
          <h1>Media attachment</h1>
          <p>Enable media so you can send images, documents, or videos as an attachment to the Message Template content.</p>
          <p>Visit
            <a
              href="https://developers.facebook.com/docs/whatsapp/message-templates/guidelines/"
              target="_blank">
              Creating Message Templates
            </a>
            for more information.</p>
        </b-popover> -->
      </b-form-group>
    </ValidationProvider>

    <ValidationProvider
      v-slot="{ errors }"
      ref="messageValidationProviderRef"
      name="Message"
      :rules="{
        required: true,
        noStartingPlaceholder: true,
        noEndingPlaceholder: true,
        noNeighbourPlaceholders: true,
        noPlaceholderNewline: true,
        tooLong: {
          max: maxMessageLength,
          current: rawCounter,
          message: 'Message is too long. Maximum is 1024 characters.',
        }
      }"
      :bails="false"
      class="sb-form-group">
      <b-form-group>
        <label
          for="p-message"
          class="settings__label flex flex-align-center" >
          Message
        </label>
        <SBTextInput
          id="text-field"
          ref="messageArea"
          v-model="template.text"
          :focus-shadow="true"
          placeholder="Enter message..."
          show-tags-select
          @raw-input="rawInput"
          @tag-count="tagCounterUpdate"
          @tab="tabPressed" />
        <template v-if="errors.length">
          <div
            v-for="(err, index) in errors"
            :key="index"
            class="error flex flex-align-center">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            <span>{{ err }}</span>
          </div>
        </template>
      </b-form-group>
    </ValidationProvider>

    <!-- BUTTONS -->
    <ValidationProvider
      v-slot="{ errors }"
      name="buttons"
      rules="required"
      class="sb-form-group">
      <b-form-group>
        <label
          for="p-key"
          class="settings__label flex flex-align-center" >
          Interactive buttons
        </label>
        <div id="buttons-wrapper">
          <multiselect
            v-model="buttonType"
            placeholder="Select an option"
            class="flex-options hide-tags no-selected-background"
            :options="buttonTypes"
            label="name"
            track-by="code"
            :multiple="false"
            :show-labels="false"
            :show-no-results="false"
            :clear-on-select="false"
            :preserve-search="true"
            :allow-empty="false"
            :preselect-first="true"
            :searchable="false" >
            <template
              slot="option"
              slot-scope="props">
              <p>{{ props.option.name }}</p>
            </template>
          </multiselect>
        </div>
        <div
          v-if="errors[0]"
          class="error flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ errors[0] }}</span>
        </div>
        <p
          v-if="buttonType && buttonType.code === 'buttons'"
          class="button-description" >Create up to 3 buttons that let customers respond to your message or take action.</p>
        <p
          v-if="buttonType && buttonType.code === 'actions'"
          class="button-description" >Create up to 2 buttons that let customers call a phone number or visit a website link.</p>
      </b-form-group>
    </ValidationProvider>

    <template v-if="buttonType && buttonType.code === 'buttons'">
      <div
        v-for="(button, index) in buttons"
        :key="index"
        class="button-fields" >
        <ValidationProvider
          v-slot="{ errors }"
          :name="`buttons-${index}`"
          rules="required">
          <b-form-group>
            <label
              :for="`buttonInput-${index}`"
              class="settings__label flex flex-align-center" >
              <span class="greedy">Button text</span>
              <span class="character-counter">{{ buttonMaxTextLength - button.value.length }}</span>
            </label>
            <div class="option">
              <input
                :id="`buttonInput-${index}`"
                :ref="`buttonInputRef-${index}`"
                v-model="button.value"
                :maxlength="buttonMaxTextLength"
                type="text"
                class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                placeholder="Enter button text" >
              <SBIcon
                v-if="buttons.length > 1"
                class="mr-2 delete"
                :icon="SBIconList.CLOSE_THIN"
                :size="10"
                :hover-size="20"
                :color="SBColors.greyPrimary"
                :background-color="SBColors.white"
                :hover-icon-color="SBColors.blackPrimary"
                @click="removeOption(index)" />
            </div>
            <div
              v-if="errors[0]"
              class="error flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.ERROR"
                :color="SBColors.redPrimary"
                :size="12" />
              <span>Button text is required.</span>
            </div>
          </b-form-group>
        </ValidationProvider>
      </div>

      <div
        v-if="buttons.length < 3"
        class="add-more-btn"
        @click="addNewButtons">
        <span class="flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.PLUS"
            :color="SBColors.bluePrimary"
            :size="8" />
          <span>Add button</span>
        </span>
      </div>
    </template>

    <template v-if="buttonType && buttonType.code === 'menu'">
      <div
        class="button-fields" >
        <ValidationProvider
          v-slot="{ errors }"
          name="Menu title"
          rules="required">
          <b-form-group>
            <label
              for="menu-button-title"
              class="settings__label flex flex-align-center" >
              <span class="greedy">Menu title</span>
              <span class="character-counter">{{ menuItemMaxTextLength - menubuttonTitle.length }}</span>
            </label>
            <div class="option">
              <input
                id="menu-button-title"
                v-model="menubuttonTitle"
                :maxlength="buttonMaxTextLength"
                type="text"
                class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                placeholder="Enter menu title text" >
            </div>
          </b-form-group>
          <div
            v-if="errors[0]"
            class="error flex flex-align-center">
            <SBIcon
              class="mr-2"
              :icon="SBIconList.ERROR"
              :color="SBColors.redPrimary"
              :size="12" />
            <span>Menu title text is required.</span>
          </div>
        </ValidationProvider>
      </div>
      <div
        v-for="(menuItem, index) in menuItems"
        :key="index"
        class="button-fields" >
        <ValidationProvider
          v-slot="{ errors }"
          :name="`button-${index}`"
          :rules="{
            required: true,
          }" >
          <b-form-group>
            <label
              :for="`menuItemInput-${index}`"
              class="settings__label flex flex-align-center" >
              <span class="greedy">Menu item</span>
              <span class="character-counter">{{ menuItemMaxTextLength - menuItem.value.length }}</span>
            </label>
            <div class="option">
              <input
                :id="`menuItemInput-${index}`"
                :ref="`menuItemInputRef-${index}`"
                v-model="menuItem.value"
                :maxlength="menuItemMaxTextLength"
                type="text"
                class="w-100 sb2-active sb2-bordered sb2-hoverable sb2-focusable option-item mb-0"
                placeholder="Enter menu item text" >
              <SBIcon
                v-if="menuItems.length > 1"
                class="mr-2 delete"
                :icon="SBIconList.CLOSE_THIN"
                :size="10"
                :hover-size="20"
                :color="SBColors.greyPrimary"
                :background-color="SBColors.white"
                :hover-icon-color="SBColors.blackPrimary"
                @click="removeMenuItem(index)" />
            </div>
            <div
              v-if="errors[0]"
              class="error flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.ERROR"
                :color="SBColors.redPrimary"
                :size="12" />
              <span>Menu item text is required.</span>
            </div>
          </b-form-group>
        </ValidationProvider>
      </div>

      <div
        v-if="(menuItems.length < 10)"
        class="add-more-btn"
        @click="addNewMenuItem">
        <span class="flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.PLUS"
            :color="SBColors.bluePrimary"
            :size="8" />
          <span>Add menu item</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import Multiselect from 'vue-multiselect';
import SBTextInput from '@/components/business/widgets/SBTextInput';
import { getMediaTypeFromExtension, getMediaName } from '@/helpers/mediaHelpers';
import { whatsappFormatMessage, convertToTagView, whatsAppFormatToHTML, quillFormatMessage } from '@/helpers/stringHelpers';
import DropZone from '../../../common/DropZone';

export default {
  name: 'SendMessageBlock',
  components: {
    SBIcon,
    Multiselect,
    SBTextInput,
    DropZone,
  },
  props: {
    node: {
      type: Object,
      required: false,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      template: {
        attachment: null,
        text: null,
      },
      messageRawInput: '',
      tagPlaceholders: 0,
      buttonType: null,
      file: null,
      tempFileName: '',
      buttons: [],
      menuItems: [],
      actionButtons: [],
      buttonMaxTextLength: 25,
      phoneMaxTextLength: 25,
      urlMaxTextLength: 2000,
      maxMessageLength: 1020,
      menuItemMaxTextLength: 24,
      menubuttonTitle: 'Options',
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      loadingNewTemplateConfig: 'notification/loadingNewTemplateConfig',
      newTemplateConfig: 'notification/newTemplateConfig',
      flowsDefinitions: 'flows/flowsDefinitions',
    }),
    buttonTypes() {
      const buttonTypes = [
        {
          name: 'None',
          code: null,
        },
        {
          name: 'Reply buttons',
          code: 'buttons',
        },
        {
          name: 'Menu list',
          code: 'menu',
        }];

      return buttonTypes;
    },
    rawCounter() {
      const waText = this.template && this.template.text ? whatsappFormatMessage(this.template.text) : '';
      const counter = waText.length;

      const newLineRegex = new RegExp(/\n/, 'g');
      const newLineMatches = waText.match(newLineRegex) || [];
      return counter + newLineMatches.length;
    },
    mediaTypes() {
      const mediaTypes = [{
        name: 'None',
        code: null,
      }];
      if (this.newTemplateConfig && this.newTemplateConfig.attachment) {
        Object.keys(this.newTemplateConfig.attachment).forEach((mediaCode) => {
          mediaTypes.push({
            name: this.newTemplateConfig.attachment[mediaCode],
            code: mediaCode,
          });
        });
      }
      return mediaTypes;
    },
  },
  watch: {
    buttonType() {
      if (this.buttonType && this.buttonType.code === 'buttons') {
        if (!this.buttons.length) {
          this.addNewButtons();
        } else {
          const targetButton = 'buttonInputRef-0';
          setTimeout(() => {
            this.$refs[targetButton][0].focus();
          }, 0);
        }
      } else if (this.buttonType && this.buttonType.code === 'menu') {
        if (!this.menuItems.length) {
          this.addNewMenuItem();
        } else {
          const targetButton = 'menuItemInputRef-0';
          setTimeout(() => {
            this.$refs[targetButton][0].focus();
          }, 0);
        }
      }
    },
  },
  beforeDestroy() {
    // this.clearData();
  },
  mounted() {
    if (this.editMode) {
      this.populateForm();
    }
  },
  methods: {
    ...mapActions({
      addFlowBlock: 'flows/addFlowBlock',
      editFlowBlock: 'flows/editFlowBlock',
      uploadTempFile: 'automation/uploadTempFile',
    }),
    addNewMenuItem() {
      this.menuItems.push({ value: '' });
      const targetMenuItem = `menuItemInputRef-${this.menuItems.length - 1}`;
      setTimeout(() => {
        this.$refs[targetMenuItem][0].focus();
      }, 0);
    },
    addNewButtons() {
      this.buttons.push({ value: '' });
      const targetButton = `buttonInputRef-${this.buttons.length - 1}`;
      setTimeout(() => {
        this.$refs[targetButton][0].focus();
      }, 0);
    },
    populateForm() {
      console.log(this.node);
      try {
        const elements = this.node.blockData.params.elements;
        // set attachment
        const attachment = elements.find(e => e.type === 'media_url');
        if (attachment) {
          this.tempFileName = attachment.value.file_name;
        }
        // Set text
        const text = elements.find(e => e.type === 'text');
        if (text) {
          this.$refs.messageArea.resetTextTo(quillFormatMessage(text.value, { parseTags: false }));
        }

        // Set buttons
        const buttons = elements.find(e => e.type === 'buttons');
        if (buttons) {
          buttons.value.items.forEach((button) => {
            this.buttons.push({ value: button.title });
          });
          this.buttonType = this.buttonTypes.find(b => b.code === 'buttons');
        }

        // Set menu
        const menu = elements.find(e => e.type === 'menu_list');
        if (menu) {
          menu.value.items.forEach((button) => {
            this.menuItems.push({ value: button.title });
          });
          this.buttonType = this.buttonTypes.find(b => b.code === 'menu');
          this.menubuttonTitle = menu.value.menu_title;
        }
      } catch (error) {}
    },
    removeOption(index) {
      this.buttons.splice(index, 1);
    },
    submit(parentId) {
      // TODO add media nad buttons
      if (
        this.$refs.messageValidationProviderRef.validate() &&
        this.$refs.mediaValidationProviderRef.validate()
      ) {
        if ((!this.file || !this.file.length) && this.tempFileName) {
          // Existing file
          const attachment = this.node.blockData.params.elements.find(e => e.type === 'media_url');
          this.submitData(parentId, { url: attachment.value.media_url, name: attachment.value.file_name, mime_type: this.node.blockData.params.elements.find(e => e.type === 'mime_type').value });
        } else if (this.file && this.file.length) {
          // New file
          // Upload the file first
          const formData = new FormData();
          formData.set('file', this.file[0]);
          this.uploadTempFile({
            businessId: this.$route.params.numberId,
            data: formData,
          })
            .then((response) => {
              this.submitData(parentId, { ...response.data, name: this.file[0].name });
            })
            .catch(() => {
              this.clearData();
            });
        } else {
          this.submitData(parentId);
        }
      }
    },
    submitData(parentId, file = null) {
      const actionsDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'SENDWAMSG');
      let buttonsElementDefinition;

      const paramsElements = [];
      // media_url & mime_type
      if (file) {
        buttonsElementDefinition = actionsDefinition.definition.elements.find(e => e.type === 'media_url');
        paramsElements.push({
          type: buttonsElementDefinition.type,
          value: {
            file_name: file.name,
            media_url: file.url,
          },
        });
        buttonsElementDefinition = actionsDefinition.definition.elements.find(e => e.type === 'mime_type');
        paramsElements.push({
          type: buttonsElementDefinition.type,
          value: file.mime_type,
        });
      }
      // text
      if (this.template.text) {
        buttonsElementDefinition = actionsDefinition.definition.elements.find(e => e.type === 'text');
        paramsElements.push({
          type: buttonsElementDefinition.type,
          value: whatsappFormatMessage(this.template.text),
        });
      }

      // buttons
      if (this.buttonType && this.buttonType.code === 'buttons') {
        const buttonList = [];
        this.buttons.forEach((button) => {
          buttonList.push({ title: button.value });
        });
        buttonsElementDefinition = actionsDefinition.definition.elements.find(e => e.type === 'buttons');
        paramsElements.push({
          type: buttonsElementDefinition.type,
          value: { items: buttonList },
        });
      } else if (this.buttonType && this.buttonType.code === 'menu') {
        const buttonList = [];
        this.menuItems.forEach((button) => {
          buttonList.push({ title: button.value });
        });
        buttonsElementDefinition = actionsDefinition.definition.elements.find(e => e.type === 'menu_list');
        paramsElements.push({
          type: buttonsElementDefinition.type,
          value: { items: buttonList, menu_title: this.menubuttonTitle },
        });
      }

      if (!this.editMode) {
        this.addFlowBlock({
          parentId,
          block: {
            category: actionsDefinition.meta.category,
            type: actionsDefinition.meta.type,
            params: {
              elements: paramsElements,
            },
          },
        })
          .then((response) => {
            if (response.status === 200) {
              this.$emit('finished');
              this.clearData();
            }
          });
      } else {
        this.editFlowBlock({
          blockId: this.node.id,
          block: {
            category: actionsDefinition.meta.category,
            type: actionsDefinition.meta.type,
            params: {
              elements: paramsElements,
            },
          },
        })
          .then((response) => {
            if (response.status === 200) {
              this.$emit('finished');
              this.clearData();
            }
          });
      }
    },
    resetExample() {
      this.exampleUrl = '';
      this.files = [];
      if (this.$refs.dropZone) {
        this.$refs.dropZone.clearFiles();
      }
    },
    clearData() {
      this.template = {
        attachment: null,
        text: null,
      };
    },
    rawInput(ri) {
      this.messageRawInput = ri ? ri.replace(/\n$/g, '') : '';
    },
    tagCounterUpdate(count) {
      this.tagPlaceholders = count;
    },
    tabPressed() {
      if (this.$refs.attachmentElementRef) {
        this.$refs.attachmentElementRef.$el.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sb-form-group {
  .settings__label {
    margin-top: 15px !important;
  }

  &:first-child {
    .settings__label {
      margin-top: 0 !important;
    }
  }
}


// Buttons
.add-more-btn {
  display: inline-block;
  color: $bluePrimary;
  padding: 0 0 0 0;
  margin-top: 15px;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    ::v-deep .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }
}

.option {
  position: relative;

  .option-item {
    margin-bottom: 10px;
  }

  .delete {
    // display: none;
    position: absolute;
    top: 7px !important;
    right: 7px !important;
    margin-right: 0 !important;
    cursor: pointer;
  }

  .error {
    margin-top: -5px;
    margin-bottom: 10px;
  }

  &:hover {
    .delete {
      display: flex;
    }
  }
}

.action-button-fields {
  margin-top: 12px;

  &:first-of-type {
    margin-top: 20px;
  }

  .form-group {
    margin-bottom: 0px !important;
  }
}

.action-option {
  background-color: #ffffff;
  padding: 12px 5px;
  box-shadow: 0 1px 3px 0 rgba(68, 76, 100, 0.1) !important;
  border: solid 1px #cfd8dc !important;
  border-radius: 5px !important;

  .row {
    margin-right: 0;
    margin-left: 0;
    gap: 0px !important;
    margin-bottom: 0px !important;
  }

  [class^='col'], div[class*=' col'] {
    padding: 0 5px;
  }

  .settings__label {
    margin-top: 0px !important;
  }
}

.button-fields {
  .settings__label {
    margin-top: 15px !important;
    font-weight: 400 !important;
  }
}

.button-description {
  margin-top: 8px;
  line-height: 1.21;
  font-size: 14px;
  font-weight: 400;
  color: $blackUltralight;
}

.dynamic-url-part {
  padding-top: 30px;
  padding-left: 10px;
}

.character-counter {
  font-size: 14px !important;
  font-weight: normal !important;
  color: $blackUltralight !important;
  text-align: end;
}

::v-deep .white-bg .modal-body {
  background-color: $white !important;
}

::v-deep .multiselect .multiselect__option.multiselect__option--disabled {
  color: #9EAFB5 !important;
  background: $white !important;
}
</style>
